import { useState } from 'react';
import { Modal, Form, Input, Alert, Button, message } from 'antd';
import { api } from '../../services/api';

// Qué pasó con el alta según el server. En una tienda con ERP el cliente se da
// de alta allá primero; si el ERP no responde queda pendiente y se sincroniza
// con su primer pedido.
const AVISOS = {
  creado:    { tipo: 'success', texto: 'Cliente creado, también en el ERP' },
  existente: { tipo: 'success', texto: 'Ya estaba en el ERP: se trajeron sus datos' },
  pendiente: { tipo: 'warning', texto: 'Cliente creado. El ERP no respondió: se va a dar de alta allá con su primer pedido' },
  sin_erp:   { tipo: 'success', texto: 'Cliente creado' },
};

// ClienteFormModal da de alta un cliente desde el admin. Lo usan la pantalla de
// clientes y la de nuevo pedido, para venderle a alguien que no pasó por la web.
// accionExistente: qué ofrecer cuando el cliente ya existe, por ejemplo abrirlo
// (admin) o elegirlo para el pedido (vendedor): { label, onClick(cliente) }.
export const ClienteFormModal = ({ open, onClose, onCreado, accionExistente }) => {
  const [form] = Form.useForm();
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');
  const [existente, setExistente] = useState(null);

  const cerrar = () => {
    form.resetFields();
    setError('');
    setExistente(null);
    onClose();
  };

  const guardar = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }
    // Con uno de los dos no se duplica: si ya existe, se lo reconoce.
    if (!values.dni?.trim() && !values.cuit?.trim()) {
      setError('Cargá el DNI o el CUIT.');
      return;
    }
    setGuardando(true);
    setError('');
    setExistente(null);
    try {
      const res = await api.admin.crearCliente(values);
      if (res.status === 'duplicado') {
        setError(res.message);
        setExistente(res.data || null);
        return;
      }
      if (res.status !== 'success') {
        setError(res.message || 'No se pudo guardar el cliente.');
        return;
      }
      const aviso = AVISOS[res.data.erp] || AVISOS.sin_erp;
      message[aviso.tipo](aviso.texto, 5);
      form.resetFields();
      onCreado(res.data.cliente);
    } finally {
      setGuardando(false);
    }
  };

  return (
    <Modal
      open={open}
      title="Nuevo cliente"
      okText="Crear cliente"
      onOk={guardar}
      onCancel={guardando ? undefined : cerrar}
      confirmLoading={guardando}
      destroyOnHidden
    >
      {error && (
        <Alert
          type={existente ? 'warning' : 'error'}
          message={error}
          style={{ marginBottom: 12 }}
          action={existente && accionExistente && (
            <Button size="small" onClick={() => { const c = existente; cerrar(); accionExistente.onClick(c); }}>
              {accionExistente.label}
            </Button>
          )}
        />
      )}
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item label="Nombre o razón social" name="nombre"
          rules={[{ required: true, whitespace: true, message: 'El nombre es obligatorio' }]}>
          <Input autoFocus />
        </Form.Item>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <Form.Item label="DNI" name="dni" style={{ flex: '1 1 160px' }}>
            <Input inputMode="numeric" placeholder="12345678" />
          </Form.Item>
          <Form.Item label="CUIT" name="cuit" style={{ flex: '1 1 160px' }}>
            <Input placeholder="20-12345678-9" />
          </Form.Item>
        </div>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <Form.Item label="Mail" name="mail" rules={[{ type: 'email', message: 'Revisá el mail' }]}
            style={{ flex: '1 1 200px' }}>
            <Input />
          </Form.Item>
          <Form.Item label="Teléfono" name="telefono" style={{ flex: '1 1 140px' }}>
            <Input />
          </Form.Item>
        </div>
        <Form.Item label="Domicilio" name="domicilio">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
